import { Navigate, Route, Routes } from 'react-router-dom';
import RequireAccess from '../../../authorization/RequireAccess';
import { ACCESS } from '../../../constants/authz';
import TemplateListPage from './TemplateListPage.jsx';
import TemplateCreatePage from './TemplateCreatePage.jsx';
import TemplateEditPage from './TemplateEditPage.jsx';
import TemplateDetailsPage from './TemplateDetailsPage.jsx';
import TemplateUsersPage from './TemplateUsersPage.jsx';
import WabaAppListPage from './WabaAppListPage.jsx';
import WabaAppDetailsPage from './WabaAppDetailsPage.jsx';
import OptinUsersPage from './OptinUsersPage.jsx';
import TemplateQueuePage from './TemplateQueuePage.jsx';
import TemplateQueueItemsPage from './TemplateQueueItemsPage.jsx';

function PerformanceDashboardRoute({ children }) {
  return (
    <RequireAccess access={ACCESS.WHATSAPP_TEMPLATE_PERFORMANCE}>
      {children}
    </RequireAccess>
  );
}

export default function WhatsappTemplatesRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="/template-list" replace />} />
      <Route path="/template-list" element={<TemplateListPage />} />
      <Route path="/reports" element={<Navigate to="/template-details" replace />} />
      <Route
        path="/template-details"
        element={(
          <PerformanceDashboardRoute>
            <TemplateDetailsPage />
          </PerformanceDashboardRoute>
        )}
      />
      <Route path="/create-template" element={<TemplateCreatePage />} />
      <Route path="/edit-template/:templateName/:botNumber" element={<TemplateEditPage />} />
      <Route
        path="/template-details/:templateName/:botNumber"
        element={(
          <PerformanceDashboardRoute>
            <TemplateDetailsPage />
          </PerformanceDashboardRoute>
        )}
      />
      <Route
        path="/template-users/:templateName/:templateId/:templateSentDate"
        element={(
          <PerformanceDashboardRoute>
            <TemplateUsersPage />
          </PerformanceDashboardRoute>
        )}
      />
      <Route path="/manager/app-list" element={<WabaAppListPage />} />
      <Route path="/manager/app-details" element={<WabaAppDetailsPage />} />
      <Route path="/optin-users" element={<OptinUsersPage />} />
      <Route
        path="/template-queue"
        element={(
          <RequireAccess access={ACCESS.SUPER_ADMIN_ONLY}>
            <TemplateQueuePage />
          </RequireAccess>
        )}
      />
      <Route
        path="/template-queue/:jobId"
        element={(
          <RequireAccess access={ACCESS.SUPER_ADMIN_ONLY}>
            <TemplateQueueItemsPage />
          </RequireAccess>
        )}
      />
    </Routes>
  );
}
